<template>
  <el-dialog
    title="提示"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="no-mobile-notice-body" v-html="noticeText"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleAck" :loading="ackLoading">我知道了</el-button>
      <el-button type="primary" @click="handleAddMobile" :loading="ackLoading"
        >添加手机号</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import request from "@/utils/request.js";
import { getToken } from "@/utils/util.js";
import { setUserInfo } from "@/utils/auth.js";
import {
  shouldShowNoMobileDialog,
  isNoMobileNoticeChecked,
  markNoMobileNoticeChecked,
  registerNoMobileNoticeChecker,
} from "@/utils/noMobileNotice.js";

const DEFAULT_NOTICE_TEXT =
  "您尚未绑定手机号，请尽快添加手机号以便接收重要通知。";

const SKIP_PATH_PREFIXES = [
  "/login",
  "/register",
  "/studentRegister",
  "/teacherRegister",
  "/findAccount",
  "/loginMiddle",
];

export default {
  name: "NoMobileNoticeDialog",
  data() {
    return {
      visible: false,
      noticeText: "",
      ackLoading: false,
      checking: false,
    };
  },
  mounted() {
    registerNoMobileNoticeChecker(() => this.scheduleCheck());
  },
  beforeDestroy() {
    registerNoMobileNoticeChecker(null);
  },
  methods: {
    shouldSkipRoute(path) {
      return SKIP_PATH_PREFIXES.some(
        (p) => path === p || path.startsWith(p + "/")
      );
    },
    scheduleCheck() {
      this.$nextTick(() => {
        this.checkNotice();
      });
    },
    async checkNotice() {
      if (this.checking || this.visible || !getToken()) return;
      if (isNoMobileNoticeChecked()) return;
      if (this.shouldSkipRoute(this.$route.path)) return;

      this.checking = true;
      try {
        const res = await request({
          url: "/front/individual/hasMobile",
          method: "get",
        });
        if (!res || res.code != 0) return;

        if (!shouldShowNoMobileDialog(res.data)) {
          this.visible = false;
          return;
        }

        await this.loadNoticeText();
        this.visible = true;
      } catch (e) {
        console.error("检查手机号提示失败", e);
      } finally {
        this.checking = false;
        markNoMobileNoticeChecked();
      }
    },
    async loadNoticeText() {
      try {
        const res = await request({
          url: "/front/individual/userInfo",
          method: "get",
        });
        if (res && res.code == 0 && res.data) {
          setUserInfo(res.data);
          this.noticeText =
            res.data.noMobileNoticeText || DEFAULT_NOTICE_TEXT;
          return;
        }
      } catch (e) {
        console.error("加载手机号提示文案失败", e);
      }
      this.noticeText = DEFAULT_NOTICE_TEXT;
    },
    async submitAck() {
      if (this.ackLoading) return;
      this.ackLoading = true;
      try {
        const res = await request({
          url: "/front/individual/ackNoMobileNotice",
          method: "post",
        });
        if (res && res.code != 0) {
          this.$message.error((res && res.msg) || "操作失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.ackLoading = false;
      }
    },
    async handleAck() {
      await this.submitAck();
      this.visible = false;
    },
    async handleAddMobile() {
      await this.submitAck();
      this.visible = false;
      if (this.$route.path !== "/user/setting") {
        this.$router.push("/user/setting");
      }
    },
  },
};
</script>

<style scoped>
.no-mobile-notice-body {
  max-height: 50vh;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  word-break: break-word;
}

.no-mobile-notice-body ::v-deep img {
  max-width: 100%;
  height: auto;
}

.no-mobile-notice-body ::v-deep p {
  margin: 0 0 0.75em;
}

.no-mobile-notice-body ::v-deep p:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
